<template>
  <v-layout row wrap>
    <v-flex xs8 class="text-center">
      <v-alert type="info" :value="fromTopUp">
        <p>
          Topup request received, check your phone and enter your Mpesa pin
        </p>
      </v-alert>
      <v-list>
        <v-divider class="my-2"></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="body-2"
              >Balance {{ $app.formatMoney(balance.actual) }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="caption text--accent">
              Actual amount in your account incl. blocked
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="body-2"
              >Limit {{ $app.formatMoney(balance.limit) }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="caption text--accent">
              Maximum amount you can spend with a zero balance
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider class="my-2"></v-divider>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title class="body-2"
              >Spent this month {{ $app.formatMoney(balance.spent) }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="caption text--accent-1">
              Actual amount spent in the last 30 days
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-show="false">
          <v-list-tile-content>
            <v-list-tile-title class="body-2"
              >Blocked {{ $app.formatMoney(balance.blocked) }}
            </v-list-tile-title>
            <v-list-tile-sub-title class="caption text--accent">
              Amount charged pending service completion
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-chip label small color="accent" text-color="white">
            You are on {{ $auth.user().client.accountType }} account
          </v-chip>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-btn
              color="primary"
              @click.native="$router.push({ name: 'topUp', params: {} })"
            >
              Top Up Your Account
            </v-btn>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-btn small @click.native="refreshBalance">
              <v-icon left>refresh</v-icon>
              Refresh
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-flex>
  </v-layout>
</template>

<script>
import Base from './Base.vue'
export default {
  extends: Base,
  props: {
    fromTopUp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      balance: 0
    }
  },
  methods: {
    refreshBalance() {
      this.$app.log('refreshBalance')
      this.balance = 0
      if (
        this.$auth.check() &&
        !this.isAdmin() &&
        !this.isSupplier() &&
        !this.isOperations()
      ) {
        this.axios.get('balance').then(response => {
          this.balance = response.data.data
        })
      }
    }
  },
  mounted() {
    this.refreshBalance()
    // eslint-disable-next-line no-undef
    // var db = firebase.firestore()
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Accounts.vue